import Image from "next/image";
import styled from "styled-components";
import { colors, spacing, textStyles, toCSS } from "design-system/foundation";
import { breakpoints } from "styles";

export const PausedContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: ${spacing["5xl"]};
`;

export const PausedImage = styled(Image)`
  width: 200px;
  height: 200px;
`;

export const PausedTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
  padding: ${spacing.none} ${spacing["2xl"]};
  text-align: center;

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const TextTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)}
  color: ${colors.text.base.primary};
`;

export const TextDesc = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Regular)}
  color: ${colors.text.base.secondary};
`;

export const ButtonGroup = styled.div`
  width: 100%;
  padding: ${spacing.none} ${spacing["2xl"]} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;
